module.exports = __webpack_public_path__ + "static/records-confirmation-popup-858610e6ff0b73da2febe54525b251ae.png";